// src/components/GoogleAnalytics.tsx
import { useEffect } from "react";
import { withRouter } from "react-router";
import ReactGA from "../analytics";

const GoogleAnalytics = ({ location }: any) => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      const GA_ID = import.meta.env.REACT_APP_GA_TOKEN;
      ReactGA.initialize(GA_ID, {
        gtagOptions: {
          debug_mode: window.location.hostname === "development.looc-c.d61.io"
        }
      });

      ReactGA.set({ anonymizeIp: true });
    }
  }, []);

  useEffect(() => {
    if (import.meta.env.PROD) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search
      });
    }
  }, [location]);

  return null;
};

export default withRouter(GoogleAnalytics);
